import gql from 'graphql-tag';

export const LOGIN = gql`
  mutation login($email: String!, $password: String!){
    login(
      email: $email
      password:$password
    )
  }
`;

export const NEW_EMAIL_TEMPLATE = gql`
  mutation newEmailTemplate($input: NewTemplateEmailInput){
    newEmailTemplate(input: $input){
      id
    }
  }
`;
export const ATENDIMENTO = gql`
  mutation atendimento($input: Atendimento){
    atendimento(input: $input){
      id
    }
  }
`;
export const DONATION_REPORT = gql`
  mutation donationReport($init:String, $finit:String){
    donationReport(init: $init, finit: $finit)
  }
`;
export const EMAIL_REPORT = gql`
  mutation emailReport($init:String, $finit:String){
    emailReport(init: $init, finit: $finit)
  }
`;
/* export const GENERAL_HISTORY_REPORT = gql`
  mutation generalHistoryReport($init:String, $finit:String){
    generalHistoryReport(init: $init, finit: $finit)
  }
` */

export const REGISTER_DONATOR = gql`
  mutation RegisterDonatorSite(
    $name: String!,
    $document: String,
    $email: String,
    $last_name: String,
    $street: String,
    $number: String,
    $complement: String,
    $neighborhood: String,
    $person_type: String,
    $city: String,
    $birthday: String,
    $state: String,
    $zipcode: String,
    $tel_res: String,
    $tel_com: String,
    $country: String,
    $tel_cel: String,
    $sex: String,
    $informative: String,
    $recurrence_value: String,
    $maturity_day: String,
    $donator_status_id: String,
    $shipping_method_id: String,
    $donator_type_id: String,
    $payment_form_id: String,
    $bank: String,
    $bank_account: String,
    $agency: String,
    $card_number: String)
  {
    RegisterDonatorSite(
      name: $name,
      document: $document,
      email: $email,
      last_name: $last_name,
      street: $street,
      number: $number,
      complement: $complement,
      neighborhood: $neighborhood,
      person_type: $person_type,
      city: $city,
      state: $state,
      country: $country,
      zipcode: $zipcode,
      birthday: $birthday,
      tel_res: $tel_res,
      tel_com: $tel_com,
      tel_cel: $tel_cel,
      sex: $sex,
      informative: $informative,
      recurrence_value: $recurrence_value,
      maturity_day: $maturity_day,
      donator_status_id: $donator_status_id,
      shipping_method_id: $shipping_method_id,
      donator_type_id: $donator_type_id,
      payment_form_id: $payment_form_id,
      bank: $bank,
      bank_account: $bank_account,
      agency: $agency,
      card_number: $card_number) {id}
  }
`;
export const UPDATE_DONATOR = gql`
  mutation UpdateDonatorSite(
    $id: ID!,
    $name: String!,
    $document: String!,
    $email: String!,
    $last_name: String!,
    $street: String!,
    $number: String!,
    $complement: String,
    $neighborhood: String!,
    $person_type: String,
    $city: String!,
    $birthday: String!,
    $state: String!,
    $zipcode: String!,
    $tel_res: String,
    $tel_com: String,
    $country: String!,
    $tel_cel: String!,
    $sex: String!,
    $informative: String,
    $recurrence_value: String,
    $maturity_day: String,
    $donator_status_id: String,
    $shipping_method_id: String,
    $donator_type_id: String,
    $payment_form_id: String,
    $bank: String,
    $bank_account: String,
    $agency: String,
    $card_number: String)
  {
    UpdateDonatorSite(
      id: $id,
      name: $name,
      document: $document,
      email: $email,
      last_name: $last_name,
      street: $street,
      number: $number,
      complement: $complement,
      neighborhood: $neighborhood,
      person_type: $person_type,
      city: $city,
      state: $state,
      country: $country,
      zipcode: $zipcode,
      birthday: $birthday,
      tel_res: $tel_res,
      tel_com: $tel_com,
      tel_cel: $tel_cel,
      sex: $sex,
      informative: $informative,
      recurrence_value: $recurrence_value,
      maturity_day: $maturity_day,
      donator_status_id: $donator_status_id,
      shipping_method_id: $shipping_method_id,
      donator_type_id: $donator_type_id,
      payment_form_id: $payment_form_id,
      bank: $bank,
      bank_account: $bank_account,
      agency: $agency,
      card_number: $card_number) {id}
  }
`;

export const CLOSEDAILYROUTINE = gql`
  mutation closeDailyRoutine($task: Int, $payment_form: Int, $bank: String) {
    closeDailyRoutine(task: $task, payment_form: $payment_form, bank: $bank){
      id
    }
  }
`;
export const DAILYROUTINE = gql`
  query dailyRoutineToday($task: Int, $payment_form: Int, $bank: String) {
    dailyRoutineToday(task: $task, payment_form: $payment_form, bank: $bank)
    {
      today
      total
    }
  }
`;

export const CAMPANGNS = gql`
query Campangns($page:Int!, $count:Int!,  $orderBy: [OrderByClause!]){
 campangns(page: $page, count: $count,  orderBy: $orderBy){
   paginatorInfo {
     total
   }
   data{
     id
     name
     saldo
     slug
     total_sum
     created_at
     started_at
     finished_at
     donations{
       id
       amount
       maturity_date
       payment_date
       our_number
       payment_form{
         id
         name
       }
       donator{
         id
         full_name
         email
         document
         tel_res
         tel_cel
         created_at
       }
     }
   }
 }
}
`;
export const CAMPANGNS_ALL = gql`
query Campangns{
 campangns{
     id
     name
 }
}
`;

export const DONATOR = gql`
  query Donator($id: ID!){
    donator(id: $id){
      id
      name
      document
      email
      last_name
      full_name
      street
      number
      complement
      neighborhood
      person_type
      city
      state
      zipcode
      tel_res
      birthday
      tel_com
      tel_cel
      created_at
      updated_at
      sex
      sms
      informative
      recurrence_value
      maturity_day
      donator_status{
        id
        name
      }
      shipping_method{
        id
        name
      }
      donator_type{
        id
        name
      }
      payment_form{
        id
        name
      }
      donator_history{
        id
        donator_id
        description
        user{
          id
          name
        }
        title
        type
        email_send_date
        email_sent
        created_at
      }
      journal
      bank
      bank_account
      agency
      card_number
      donation{
        id
        amount
        paid_amount
        received_amount
        description
        purse
        url_ticket_payment
        payment_form
        {
          id
          name
        }
        donation_status
        {
          id
          name
        }
        card_number
        payment_date
        maturity_date
        extra
        our_number
        transaction_code
        tax
        campangn{
          id
          name
        }
        channel
      }
    }
  }
`;

export const EMAIL_TEMPLATES = gql`
  query emailTemplates($page:Int!, $count:Int!,  $orderBy: [OrderByClause!]){
      emailTemplates(page: $page, count: $count,  orderBy: $orderBy){
        paginatorInfo {
          total
        }
        data{
            id
            name
            subject
            body
            type
        }
      }
  }
`;
export const EMAIL_TEMPLATE_ALL = gql`
  query emailTemplateAll{
      emailTemplateAll{
          id
          name
          subject
          body
          type
      }
  }
`;
export const CAMPANGN = gql`
  query campangn($id:ID!){
      campangn(id: $id){
        id
        name
        created_at
        started_at
        finished_at
        email_init_id
        email_finit_id
        background
        background_color
        analitycs
        acknowledgment
      }
  }
`;
export const EMAIL_TEMPLATE = gql`
  query emailTemplate($id:ID!){
      emailTemplate(id: $id){
        id
        name
        greeting
        subject
        body
        type
        file
        salutation
      }
  }
`;

export const EMAIL_REGISTER = gql`
  query emailRegister($page:Int!, $count:Int!,  $orderBy: [OrderByClause!]){
    emailRegister(page: $page, count: $count,  orderBy: $orderBy){
      paginatorInfo {
        total
      }
      data{
        id
        donator{
          id
          name
          last_name
          email
        }
        created_at
        subject
        sent_at
        template{
          id
          name
        }
        data
        user{
          id
          name
        }
      }
    }
  }
`;

export const DONATORS = gql`
  query Donators($page:Int!, $count:Int!, $payment_form_id: [Int], $donator_status_id: [Int], $donator_type_id: [Int], $shipping_method_id: [Int]){
    donators(count: $count, page: $page, payment_form_id: $payment_form_id, donator_status_id: $donator_status_id, donator_type_id: $donator_type_id ,shipping_method_id: $shipping_method_id) {
      paginatorInfo {
        total
      }
      data {
        id
        name
        document
        email
        full_name
        street
        number
        complement
        neighborhood
        city
        state
        zipcode
        tel_res
        tel_com
        tel_cel
        created_at
        updated_at
        sex
        informative
        recurrence_value
        maturity_day
        donator_status{
          id
          name
        }
        shipping_method{
          id
          name
        }
        donator_type{
          id
          name
        }
        payment_form{
          id
          name
        }
        bank
        bank_account
        agency
        card_number
        donator_history{
          id
          donator_id
          description
          user{
            id
            name
          }
          title
          type
          email_send_date
          email_sent
          created_at
        }
      }
    }
  }
`;

export const DONATORSSTRING = gql`
  query donatorsByString($page:Int!, $count:Int!,$search_full_name: String!, $search_document: String!, $search_email: String!){
    donatorsByString(count: $count, page: $page, search_full_name: $search_full_name, search_document: $search_document, search_email:$search_email) {
      paginatorInfo {
        total
      }
      data {
        id
        name
        document
        email
        full_name
        street
        number
        complement
        neighborhood
        city
        state
        zipcode
        tel_res
        tel_com
        tel_cel
        created_at
        updated_at
        sex
        informative
        recurrence_value
        maturity_day
        donator_status{
          id
          name
        }
        shipping_method{
          id
          name
        }
        donator_type{
          id
          name
        }
        payment_form{
          id
          name
        }
        bank
        bank_account
        agency
        card_number
        donator_history{
          id
          donator_id
          description
          user{
            id
            name
          }
          title
          type
          email_send_date
          email_sent
          created_at
        }
      }
    }
  }
`;

export const RETURN_HISTORY = gql`
  query returnHistory($count: Int!, $page: Int!, $orderBy: [OrderByClause!]){
    returnHistory(count: $count, page: $page, orderBy: $orderBy){
      paginatorInfo {
        total
      }
      data{
        id
        user{
          id
          name
        }
        payment_form{
          id
          name
        }
        description
        file
        data
        status
        created_at
      }
    }
  }
`;
export const MONTH_REPORT = gql`
  query MonthReport($count: Int!, $page: Int!, $orderBy: [OrderByClause!]){
    MonthReport(count: $count, page: $page, orderBy: $orderBy){
      paginatorInfo {
        total
      }
      data{
        id
        name
        sent_at
        file
      }
    }
  }
`;

export const DAILY_ROUTINES_HISTORY = gql`
  query dailyRoutinesHistory($count: Int!, $page: Int!, $orderBy: [OrderByClause!]){
    dailyRoutinesHistory(count: $count, page: $page, orderBy: $orderBy){
      paginatorInfo {
        total
      }
      data{
        id
        user{
          id
          name
        }
        bank
        payment_form{
          id
          name
        }
        task{
          id
          title
          description
        }
        created_at
      }
    }
  }
`;

export const GENERAL_HISTORY = gql`
  query History($count: Int!, $page: Int!, $orderBy: [OrderByClause!]){
    History(count: $count, page: $page, orderBy: $orderBy){
      paginatorInfo {
        total
      }
      data{
        id
        user{
          id
          name
        }
        title
        description
        type
        created_at
      }
    }
  }
`;
export const EMAIL_HISTORY = gql`
  query emailHistory($count: Int!, $page: Int!, $orderBy: [OrderByClause!]){
    emailHistory(count: $count, page: $page, orderBy: $orderBy){
      paginatorInfo {
        total
      }
      data{
        id
        message_id
        email
        subject
        event
        count
        reason
        created_at
      }
    }
  }
`;

export const DONATORSSTRING2 = gql`
  query donatorsByString2($page:Int!, $count:Int!, $payment_form_id: [Int], $donator_status_id: [Int], $donator_type_id: [Int], $shipping_method_id: [Int], $filter: String, $orderBy: [OrderByClause!]){
    donatorsByString2(count: $count, page: $page,  payment_form_id: $payment_form_id, donator_status_id: $donator_status_id, donator_type_id: $donator_type_id ,shipping_method_id: $shipping_method_id,search_full_name: $filter, search_document: $filter, search_email:$filter, orderBy: $orderBy) {
      paginatorInfo {
        total
      }
      data {
        id
        name
        document
        email
        full_name
        street
        number
        complement
        neighborhood
        city
        state
        zipcode
        tel_res
        tel_com
        tel_cel
        created_at
        updated_at
        sex
        informative
        recurrence_value
        maturity_day
        donator_status{
          id
          name
        }
        shipping_method{
          id
          name
        }
        donator_type{
          id
          name
        }
        payment_form{
          id
          name
        }
        bank
        bank_account
        agency
        card_number
        donator_history{
          id
          donator_id
          description
          title
          type
          email_send_date
          email_sent
          created_at
        }
      }
    }
  }
`;

export const NEW_IMAGE = gql`
  mutation newImage($file: Upload!) {
      newImage(file: $file){
        url
      }
  }
`;

export const NEW_BACKGROUND_CAMPANGN = gql`
  mutation newBackgroundCampangn($file: Upload!) {
      newBackgroundCampangn(file: $file){
        url
      }
  }
`;

export const NEW_CAMPANGN = gql`
  mutation newCampangn($name:String!, $email_init_id: Int!, $email_finit_id: Int!, $started_at:String, $background:String, $background_color: String,$analitycs: String,$acknowledgment:String, $id:String) {
      newCampangn(name:$name, email_init_id: $email_init_id, email_finit_id: $email_finit_id, started_at:$started_at, background:$background, acknowledgment:$acknowledgment,background_color:$background_color,analitycs:$analitycs, id:$id){
        id
      }
  }
`;
export const FINISH_CAMPANGN = gql`
  mutation finishCampangn($finished_at:String!,  $id:String!) {
      finishCampangn(finished_at:$finished_at,  id:$id){
        id
      }
  }
`;
export const NEW_REMESSA = gql`
  mutation newRemessa($type: String!, $date: String, $donators: [String!]!, $campangn: String, $value: String) {
      newRemessa(type: $type, donators: $donators, date: $date, campangn: $campangn, value: $value)
  }
`;

export const UPLOAD_BOLETO_ITAU = gql`
  mutation uploadBoletoItau($file: Upload!) { uploadBoletoItau(file: $file){
    tipo_registro
    codigo_inscricao
    numero_inscricao
    agencia
    zeros1
    conta
    dac
    brancos1
    uso_empresa
    nosso_numero1
    brancos2
    carteira
    nosso_numero2
    dac_nosso_numero
    brancos3
    carteira2
    codigo_ocorrencia
    data_ocorrencia
    numero_documento
    nosso_numero3
    brancos4
    vencimento
    valor_titulo
    codigo_banco
    agencia_cobradora
    dac_agencia_cobradora
    especie
    tarifa_cobranca
    brancos5
    valor_iof
    valor_abatimento
    descontos
    valor_principal
    juros
    outros_creditos
    boleto_dda
    brancos6
    data_credito
    instrucao_cancelada
    brancos7
    zeros2
    nome_pagador
    brancos8
    erros
    brancos9
    codigo_liquidacao
    numero_sequencial
    mensagem
  }
  }
`;
export const UPLOAD_DEBITO_ITAU = gql`
  mutation uploadDebitoItau($file: Upload!) { uploadDebitoItau(file: $file){
    codigo_banco
    codigo_lote
    tipo_registro
    numero_registro
    segmento
    codigo
    compensacao
    banco
    zero1
    agencia
    branco1
    zeros2
    conta
    branco2
    dac
    nome
    seu_numero
    branco3
    data_agendada
    tipo
    quantidade
    valor_agendado
    nosso_numero
    data_cobrada
    valor_cobrado
    tipo_mora
    valor_mora
    complement
    branco4
    numero_inscricao
    ocorrencias
    nota
  }
  }
`;
export const UPLOAD_DEBITO_SANTANDER = gql`
  mutation uploadDebitoSantander($file: Upload!) { uploadDebitoSantander(file: $file){
    codigo_registro
    identificacao_cliente_empresa
    agencia
    identificacao_cliente_banco
    vencimento_debito
    valor_debito
    codigo_retorno
    uso_empresa
    tipo_identificacao
    identificacao
    filler
    codigo_movimento
    doador
    nota
  }
  }
`;

export const DONATOR_BY_EMAIL = gql`
  query donatorByEmail($email: String!){
    donatorByEmail(email: $email){
      id
    }
  }
`;

export const DONATOR_BY_CPF = gql`
  query donatorByCPF($cpf: String!){
    donatorByCPF(cpf: $cpf){
      id
    }
  }
`;
export const GRAPH1 = gql`
  query graphs{
    graphs
  }
`;

export const CREDIT_CARD_CHART = gql`
  query creditCardCharts($init:String, $finit:String){
    creditCardCharts(init:$init, finit:$finit)
  }
`;

export const TRANSFERENCIA_CHART = gql`
  query transferenciaData($paymentForm: Int!, $init:String, $finit:String){
    transferenciaData(paymentForm: $paymentForm,init:$init, finit:$finit)
  }
`;

export const TRANSFERENCIA_CHART2 = gql`
  query transferenciaData2($paymentForm: Int!, $init:String, $finit:String){
    transferenciaData2(paymentForm: $paymentForm, init:$init, finit:$finit)
  }
`;
export const TRANSFERENCIA_CHART3 = gql`
  query transferenciaData3($paymentForm: Int!, $init:String, $finit:String){
    transferenciaData3(paymentForm: $paymentForm,init:$init, finit:$finit)
  }
`;
export const TRANSFERENCIA_CHART4 = gql`
  query transferenciaData4($paymentForm: Int!, $init:String, $finit:String){
    transferenciaData4(paymentForm: $paymentForm, init:$init, finit:$finit)
  }
`;
export const TRANSFERENCIA_CHART5 = gql`
  query transferenciaData5($paymentForm: Int!, $init:String, $finit:String){
    transferenciaData5(paymentForm: $paymentForm, init:$init, finit:$finit)
  }
`;
export const TOTAL = gql`
  query total($init:String, $finit:String){
    total(init:$init, finit:$finit)
  }
`;
export const DEBIT_SANTANDER_CHART = gql`
  query debitSantanderCharts($period:String){
    debitSantanderCharts(period:$period)
  }
`;
export const ITAU_CHART = gql`
  query ItauCharts($init:String, $finit:String){
    ItauCharts(init:$init, finit:$finit)
  }
`;
export const EXTRA_CHART = gql`
  query ExtraCharts($init:String, $finit:String){
    ExtraCharts(init:$init, finit:$finit)
  }
`;
export const NEW_DONATION = gql`
  mutation newDonation($donator: Int!, $payment_form_id: Int!, $value: String!, $vencimento: String, $card_number: String,$card_maturity: String, $campangn_id: String) {
    newDonation(donator: $donator, payment_form_id: $payment_form_id, value: $value, vencimento: $vencimento, card_number: $card_number,card_maturity: $card_maturity, campangn_id:$campangn_id)
  }
`;
export const InQueueEmail = gql`
  mutation inQueueEmails($emails: [String]) {
    inQueueEmails(emails: $emails)
  }
`;
export const deleteEmails = gql`
  mutation deleteEmails($emails: [String]) {
    deleteEmails(emails: $emails)
  }
`;
export const LAST_DONATORS = gql`
 query lastDonators {
   lastDonators {
     id
     full_name
     email
     document
     created_at
   }
 }
`;
